import { postRequest, } from "../../utils/api"

// 查询微信退款列表
export function listWxxrefund(query) {
  return postRequest('/api/refund/page',query);
}